'use client'

import { useState, useEffect } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import { ChevronLeft, Home, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface MobileNavigationGesturesProps {
  currentPage: string
  parentPage?: {
    name: string
    href: string
  }
  showHomeButton?: boolean
}

export function MobileNavigationGestures({
  currentPage,
  parentPage,
  showHomeButton = true,
}: MobileNavigationGesturesProps) {
  const router = useRouter()
  const pathname = usePathname()
  const [canGoBack, setCanGoBack] = useState(false)

  useEffect(() => {
    // Verificar si hay historial para navegar hacia atrás
    setCanGoBack(window.history.length > 1)
  }, [pathname])

  const handleGoBack = () => {
    if (canGoBack) {
      router.back()
    } else {
      // Si no hay historial, ir a la página padre o home
      router.push(parentPage?.href || '/')
    }
  }

  const handleGoHome = () => {
    router.push('/')
  }

  return null
}

// Componente específico para productos
export function ProductMobileNavigation({
  productName,
  categoryName,
  categorySlug,
}: {
  productName: string
  categoryName?: string
  categorySlug?: string
}) {
  return (
    <MobileNavigationGestures
      currentPage={productName}
      parentPage={
        categoryName && categorySlug
          ? {
              name: categoryName,
              href: `/categorias/${categorySlug}`,
            }
          : {
              name: 'Productos',
              href: '/productos',
            }
      }
    />
  )
}

// Componente específico para categorías
export function CategoryMobileNavigation({
  categoryName,
}: {
  categoryName: string
}) {
  return (
    <MobileNavigationGestures
      currentPage={categoryName}
      parentPage={{
        name: 'Categorías',
        href: '/categorias',
      }}
    />
  )
}
